import { useState } from "react";
import './AddProduct.css';

function AddProduct() {
  const [form, setForm] = useState({
    product_name: "",
    product_price: "",
    image: null,
    image2: null,
    image3: null,
    image4: null,
    image5: null,
    category: "",
  });
  const [preview, setPreview] = useState(null);
  
const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.product_name || !form.product_price || !form.category) {
      alert("Please fill all fields");
      return;
    }
    const formData = new FormData();
    formData.append("product_name", form.product_name);
    formData.append("product_price", form.product_price);
    formData.append("category", form.category);
    // formData.append("image", form.image);
    // formData.append("image2", form.image2);
    // formData.append("image3", form.image3);
    // formData.append("image4", form.image4);
    // formData.append("image5", form.image5);
      ["image","image2","image3","image4","image5"].forEach(key => {
    if (form[key]) formData.append(key, form[key]);
  });






    try {
      setLoading(true);
//       for (let [key, value] of formData.entries()) {
//   console.log(key, value);
// }
      const res =  await fetch("https://citrine-backend-0hws.onrender.com/api/products", {
        method: "POST",
        body: formData,
      });

    const data = await res.json();
    if (!res.ok) {
      throw new Error(data.message || "Failed to add product");
    }
      setForm({
        product_name: "",
        product_price: "",
        category: "",
        image: null, image2: null,
    image3: null,
    image4: null,
    image5: null,
      });
      setPreview(null);
    } catch (err) {
      console.error(err);
      alert("Error adding product");
    }finally {
    setLoading(false); // ✅ stop loading ALWAYS
  }
  };

  return (
    <form className="add-product-form" >
        <h2 className="form-title">Add New Product</h2>

      <input
        placeholder="Name" className="form-input"
        onChange={(e) => setForm({ ...form, product_name: e.target.value })}
      />

      <input
        placeholder="Price" className="form-input"
        onChange={(e) => setForm({ ...form, product_price: e.target.value })}
      />

      <input
  list="categories" className="form-input"
  placeholder="Select or type category"
  value={form.category}
  onChange={(e) =>
    setForm({ ...form, category: e.target.value })
  }
/>

          <datalist id="categories">
            <option value="Kitchen" />
            <option value="Bathroom" />
            <option value="Other" />
          </datalist>
<div  className="file-group">
      {/* <input
        type="file"
        onChange={(e) => setForm({ ...form, image: e.target.files[0] })}
      /> */}
        


    <input type="file" onChange={(e) => {
  const file = e.target.files[0];
  setForm({ ...form, image: file });
  setPreview(URL.createObjectURL(file));
}} />

<input type="file" onChange={(e) => {
  const file = e.target.files[0];
  setForm({ ...form, image2: file });
  setPreview(URL.createObjectURL(file));
}} />

<input type="file" onChange={(e) => {
  const file = e.target.files[0];
  setForm({ ...form, image3: file });
  setPreview(URL.createObjectURL(file));
}} />

<input type="file" onChange={(e) => {
  const file = e.target.files[0];
  setForm({ ...form, image4: file });
  setPreview(URL.createObjectURL(file));
}} />

<input type="file" onChange={(e) => {
  const file = e.target.files[0];
  setForm({ ...form, image5: file });
  setPreview(URL.createObjectURL(file));
}} />



</div>
      {preview && <img src={preview} alt="preview" className="preview-img" />}
<button className="submit-btn" disabled={loading} onClick={handleSubmit}>
  {loading ? "Adding..." : "Add Product"}
</button>    </form>
  );
}
export default AddProduct;
